<template>
	<table class="userTable">
		<thead>
			<tr>
				<th>Username</th>
				<th>Full Name</th>
				<th>Group</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="index in 10" :key="index">
				<td>John</td>
				<td>John Doe</td>
				<td>Admin</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
	name: "",
	components: {}
});
</script>

<style lang="scss" scoped>
.userTable {
	margin: 0 auto;

	th {
		background-color: lighten($color7, 10%);
		font-weight: 500;
		width: 140px;
	}

	th,
	td {
		border: 1px solid $border-color;
		text-align: center;
		padding: 7px 0;
	}

	td {
		background-color: $table-light-bg;
	}
}
</style>